import { render } from "./UpdateTranscript.vue?vue&type=template&id=1a73200f&scoped=true&ts=true"
import script from "./UpdateTranscript.vue?vue&type=script&lang=ts"
export * from "./UpdateTranscript.vue?vue&type=script&lang=ts"

import "./UpdateTranscript.vue?vue&type=style&index=0&id=1a73200f&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a73200f"]])

export default __exports__